import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ForecastState } from 'types';

export const initialState: ForecastState = {
  loading: false,
  forecastList: [],
  reset: false
};

const slice = createSlice({
  name: 'Forecasts',
  initialState,
  reducers: {
    setForecastList: (state, { payload }: PayloadAction<any>) => {
      state.loading = false;
      state.forecastList = payload || [];
      state.reset = false;
    },
    reset: (state) => {
      state.reset = true;
    }
  }
});

export const { setForecastList, reset } = slice.actions;

export default slice.reducer;
